<template>
  <div>
    <v-container>
      <perseu-card title="Fenômenos Tumorais">
        <template slot="title-right">
          <v-btn @click="create" color="secondary">Novo Fenômeno Tumoral</v-btn>
        </template>
        <template slot="content">
          <v-switch v-model="query.active" label="Ativos" @change="find" />
          <v-data-table :items="items" :headers="headers" class="elevation-1">
            <template v-slot:item.order="{ item }">
              <number-arrows
                :number="item.order"
                @change="(direction) => changeOrder({ item, direction })"
              />
            </template>
            <template v-slot:item.actions="{ item }">
              <table-action-button
                text="Editar"
                @click="edit(item)"
                icon="edit"
              />
              <table-action-button
                v-if="item.active"
                text="Desativar"
                @click="activeOrDeactivate(item, false)"
                icon="delete"
              />
              <table-action-button
                v-else
                text="Ativar"
                @click="activeOrDeactivate(item, true)"
                icon="check"
              />
            </template>
          </v-data-table>
        </template>
      </perseu-card>
    </v-container>
    <v-dialog v-if="dialogForm" v-model="dialogForm" max-width="800">
      <form-tumoral-phenomena
        v-model="item"
        @created="createdForm"
        @updated="updatedForm"
        @closed="dialogForm = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import {
  find,
  save,
  findOne,
  changeOrder,
} from "@/services/tumoral-phenomena-service.js";

export default {
  components: {
    "form-tumoral-phenomena": () =>
      import("@/components/TumoralPhenomena/Form"),
  },
  data: () => ({
    items: [],
    item: {},
    headers: [
      {
        text: "Número",
        value: "order",
        width: 200,
        align: "start",
      },
      { text: "Nome", value: "name" },
      {
        text: "Ações",
        value: "actions",
        width: 150,
        sortable: false,
        align: "start",
      },
    ],
    query: {
      active: true,
    },
    dialogForm: false,
  }),
  created() {
    this.find();
  },
  methods: {
    async find() {
      try {
        this.$store.dispatch("loading/openDialog");
        const { data } = await find(this.query);
        this.items = data;
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async activeOrDeactivate(item, option) {
      try {
        this.$store.dispatch("loading/openDialog");
        item.active = option;
        const { data } = await save(item);
        const index = this.findIndexItems(data);
        this.items.splice(index, 1);
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    async edit(item) {
      try {
        this.$store.dispatch("loading/openDialog");
        const { data } = await findOne(item.id);
        this.item = data;
        this.dialogForm = true;
      } catch (error) {
        this.$errorHandler(error);
      } finally {
        this.$store.dispatch("loading/closeDialog");
      }
    },
    create() {
      this.item = {};
      this.dialogForm = true;
    },
    createdForm(item) {
      this.items.push(item);
      this.dialogForm = false;
    },
    updatedForm(itemParam) {
      const index = this.findIndexItems(this.item);
      this.items.splice(index, 1, itemParam);
      this.dialogForm = false;
    },
    findIndexItems(itemParam) {
      return this.items.findIndex((item) => item.id === itemParam.id);
    },
    async changeOrder({ item, direction }) {
      try {
        await changeOrder({ tumoralPhenomenon: item, direction });
        await this.find();
      } catch (error) {
        this.$errorHandler(error);
      }
    },
  },
};
</script>

<style></style>
